/**
 * State used in rendering InteractionTagPrimary
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
